import {useState} from "react";
import {RiBankLine} from "react-icons/ri";
import {BankAccountType} from "../../api/customerBankAccounts/CustomerBankAccount.ts";
import {CreditCardSchemeLogo, detectSchemeFromCreditCardNumber} from "../specific/CreditCard";
import {appearance as lightBackgroundSchemeLogoAppearance} from "../specific/CreditCard/skins/brand/appearance.ts";

interface BankAccountLogoProps {
    logoUrl?: string | null;
    accountType?: BankAccountType;
    creditCardNumberPrefix?: string | null;
    className?: string;
}

function FallbackLogo({className}: {className: string}) {
    return (
        <span className={`${className} flex items-center justify-center rounded-full bg-superliteprimary text-primary`}>
            <RiBankLine className="h-3/5 w-3/5" />
        </span>
    );
}

export function BankAccountLogo({logoUrl, accountType, creditCardNumberPrefix, className = "size-5 shrink-0"}: BankAccountLogoProps) {
    const [imageFailed, setImageFailed] = useState(false);

    if (accountType === BankAccountType.CREDIT_CARD) {
        const scheme = detectSchemeFromCreditCardNumber(creditCardNumberPrefix ?? "");
        return (
            <span className={`${className} flex items-center justify-center`}>
                <CreditCardSchemeLogo
                    scheme={scheme}
                    size="compact"
                    appearance={lightBackgroundSchemeLogoAppearance}
                />
            </span>
        );
    }

    if (logoUrl && !imageFailed) {
        return (
            <img
                alt=""
                src={logoUrl}
                className={`${className} rounded-full`}
                onError={() => setImageFailed(true)}
            />
        );
    }

    return <FallbackLogo className={className} />;
}
